import React from "react";
import { Form } from "react-bootstrap";
import Blue_btn from "../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../common_components/common_btn/blue_border_button/Blue_border_button";

const StudentRegistration_stap_4 = ({
  register,
  errors,
  fields,
  append,
  remove,
}) => {
  return (
    <>
      <h5 className="step-heading">D. Academic Information</h5>

      {fields.map((item, index) => (
        <div className="form_holder mb-4" key={item.id}>
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>School Selection *</Form.Label>
                <Form.Control
                  {...register(`academic_info.${index}.school_selection`, {
                    required: "School Selection is required",
                  })}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Program Name *</Form.Label>
                <Form.Control
                  {...register(`academic_info.${index}.program_name`, {
                    required: "Program Name is required",
                  })}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Enrollment Status *</Form.Label>

                <div className="d-flex gap-3">
                  {/* YES */}
                  <Form.Check
                    type="radio"
                    label="Yes"
                    value="1"
                    {...register(`academic_info.${index}.enrollment_status`, {
                      required: true,
                    })}
                  />

                  {/* NO */}
                  <Form.Check
                    type="radio"
                    label="No"
                    value="0"
                    {...register(`academic_info.${index}.enrollment_status`, {
                      required: true,
                    })}
                  />
                </div>

                {errors?.academic_info?.[index]?.enrollment_status && (
                  <small className="text-danger">
                    Enrollment status is required
                  </small>
                )}
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Education Level *</Form.Label>
                <Form.Control
                  {...register(`academic_info.${index}.education_level`, {
                    required: true,
                  })}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Academic Year *</Form.Label>
                <Form.Control
                  type="date"
                  {...register(`academic_info.${index}.academic_year`, {
                    required: true,
                  })}
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Student ID *</Form.Label>
                <Form.Control
                  {...register(`academic_info.${index}.student_id_number`, {
                    required: true,
                  })}
                />
              </Form.Group>
            </div>

            {fields.length > 1 && (
              <div className="col-md-12 text-end">
                <Blue_border_button
                  button_text="Remove"
                  onClick={() => remove(index)}
                />
              </div>
            )}
          </div>
        </div>
      ))}

      <div className="text-end">
        <Blue_btn
          btn_text="Add More"
          onClick={() =>
            append({
              school_selection: "",
              program_name: "",
              enrollment_status: "",
              education_level: "",
              academic_year: "",
              student_id_number: "",
            })
          }
        />
      </div>
    </>
  );
};

export default StudentRegistration_stap_4;
